export type BaseRequestPayload = {
    url: string;
    body?: Record<string, any>;
    headers?: Record<string, string>;
    signal?: AbortSignal;
    isJson?: boolean;
};

export type PostPayload = Omit<BaseRequestPayload, 'isJson'> & {
    method: 'post';
};

export type PutPayload = Omit<BaseRequestPayload, 'isJson' | 'signal'> & {
    method: 'put';
};

export type GetPayload = Omit<BaseRequestPayload, 'body' | 'isJson'> & {
    method: 'get';
};

export type PatchPayload = Omit<BaseRequestPayload, 'isJson' | 'signal'> & {
    method: 'patch';
};

export type DeletePayload = Omit<
    BaseRequestPayload,
    'body' | 'isJson' | 'signal'
> & {
    method: 'delete';
};

export type RequestPayload =
    | PostPayload
    | PutPayload
    | PatchPayload
    | GetPayload
    | DeletePayload;

export type ErrorResponse = {
    errorCode?: number;
    error_code?: number;
    errorMessage?: string;
    errorMessageExplain?: string;
    error_message?: string;
    error_message_explain?: string;
    request_context?: {
        application_name: string | null;
        application_type_name: string | null;
        node_name: string | null;
        replica_or_instance_id: string | null;
        service_name: string | null;
        service_type_name: string | null;
    };
};

export type RequestResponse<T, S = never> = [S] extends [never]
    ? ErrorResponse & { data: T }
    : T | ErrorResponse;
